import axios from 'axios';
import host from '../config';

let baseURL ;
if (process.env.NODE_ENV === 'development') {
    baseURL = host + '/infobiz-app/public/api/tender/'
} else {
    baseURL =  host + '/api/tender/';
}
const tenderAxios = axios.create({
    baseURL
})

export default tenderAxios;